import {
  dehydrateApolloClient,
  getMaintainedParam,
  initApolloClient,
} from "../apolloClient";
import { GET_ALL_DISTRICTS } from "../../graphql/queries/regions";
import {
  FIND_LISTINGS,
  FIND_LISTINGS_WITH_SOV,
} from "../../graphql/queries/find.listings";

const isPage = new RegExp(/^[0-9]+$/);
export const Direction = {
  Resolve: async (ctx, $res) => {
    /**
     * Here I can query for listing by category,city,direction and page if
     * it exists.
     * ctx: NextPageContext {req,query,...etc.}
     *
     * */
    const { directions } = await import("./ssr/directions");
    const { description } = await import("./ssr/categories");

    const [, , direction, page, plus] = ctx?.query?.params || [];
    if (!direction) return $res({}); // break
    ctx.direction = direction;

    if (!ctx.path.city.directions) return {};
    if (!directions[direction]) throw ` جهة غير موجودة `;

    ctx.path.direction = directions[direction];
    ctx.path.isStatResults = false;

    const descriptionTemplate = description[ctx.path.category.uri];
    ctx.path.direction.description = descriptionTemplate
      ? descriptionTemplate.replace(/%place/g, ctx.path.direction.name)
      : `${ctx.path.category.name} في ${ctx.path.direction.name}`;

    ctx.path.direction.description = ctx.path.filtersAsText
      ? ctx.path.direction.description + " " + ctx.path.filtersAsText
      : ctx.path.direction.description;
    ctx.path.direction.title = `${ctx.path.category?.plural} في ${ctx.path.direction.name}`;

    ctx.path.direction.path = `/${ctx.path.category.uri}/${ctx.path.city.uri}/${ctx.path.direction.uri}`;
    if (ctx.sov) {
      ctx.sov.direction_id = ctx.path.direction?.id;
    }
    if (plus) return {}; // resume to next;
    if (page && !isPage.test(page)) return {}; // resume to next;
    ctx.path.page = parseInt(page, 10);
    if (ctx.path.page === 1) {
      return ctx.redirect(ctx.req.url.replace(`/${page}`, ""));
    }
    const client = initApolloClient();

    const pathFilters = ctx.path.filters || {};
    const { villa_type, ...filters } = pathFilters;

    const maintainedParam = getMaintainedParam(
      ctx.authState?.user?.cooperative,
    );
    const where = {
      city_id: {
        eq: ctx.path.city.id,
      },
      direction_id: {
        eq: ctx.path.direction.id,
      },

      ...filters,
      ...(filters?.price_12_payments?.gte > 1
        ? {
            price_12_payments: { gte: filters.price_12_payments.gte * 12 },
          }
        : {}),
      ...(villa_type?.eq && { villa_type: villa_type.eq }),
      unpublished: undefined,
      ...maintainedParam,
    };
    if (ctx.path.category.id) {
      where.category = {
        eq: ctx.path.category.id,
      };
    }
    await Promise.all([
      client.query({
        query: ctx.sov ? FIND_LISTINGS_WITH_SOV : FIND_LISTINGS,
        context: { aqarPlus: ctx.authState?.token },
        variables: {
          size: 20,
          from: ((ctx.path.page || 1) - 1) * 20,
          sort: {
            create_time: "desc",
            has_img: "desc",
          },
          where,
          sov: ctx.sov,
          daily_renting_filter: ctx.path.daily_renting_filter,
        },
      }),
      client.query({
        query: GET_ALL_DISTRICTS,
        variables: {
          category: ctx.path.category.id,
          city_id: ctx.path.city.id,
          direction_id: ctx.path.direction.id,
        },
      }),
    ]);

    return $res(dehydrateApolloClient(client, {}));
  },
};
export default Direction;
